/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Search: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M13.9149 6.52955C11.8755 4.49015 8.56896 4.49015 6.52955 6.52955C4.49015 8.56896 4.49015 11.8755 6.52955 13.9149C8.56896 15.9543 11.8755 15.9543 13.9149 13.9149C15.9543 11.8755 15.9543 8.56896 13.9149 6.52955ZM5.11534 5.11534C7.93579 2.29489 12.5087 2.29489 15.3291 5.11534C17.9096 7.69587 18.1291 11.7433 15.9877 14.5734L20.7071 19.2929C21.0976 19.6834 21.0976 20.3166 20.7071 20.7071C20.3166 21.0976 19.6834 21.0976 19.2929 20.7071L14.5734 15.9877C11.7433 18.1291 7.69587 17.9096 5.11534 15.3291C2.29489 12.5087 2.29489 7.93579 5.11534 5.11534Z'
      fill='currentColor'
    />
  </React.Fragment>
)
